import { notification } from 'antd';
import actions from './actions';
import { QUERY } from './query';
import { DataService } from '../../config/dataService/dataService';

const addNotificationSuccess = () => {
  notification.success({
    message: 'Company Added Successfully!',
  });
};

const addNotificationError = (err) => {
  notification.error({
    message: err,
  });
};

const deleteNotificationSuccess = () => {
  notification.success({
    message: 'Company has been Deleted',
  });
};

const deleteNotificationError = (err) => {
  notification.error({
    message: err,
  });
};

const updateNotificationSuccess = () => {
  notification.success({
    message: 'Company has been updated',
  });
};

const updateNotificationError = (err) => {
  notification.error({
    message: err,
  });
};

const {
  AddCompanyBegin,
  AddCompanySuccess,
  AddCompanyErr,

  getCompaniesBegin,
  getCompaniesSuccess,
  getCompaniesErr,

  UpdateCompanyBegin,
  UpdateCompanySuccess,
  UpdateCompanyErr,

  DeleteCompanyBegin,
  DeleteCompanySuccess,
  DeleteCompanyErr,
} = actions;

const DataSubmit = (data, callback) => {
  return async (dispatch) => {
    try {
      await dispatch(AddCompanyBegin());
      const response = await DataService.gql(QUERY.addCompany(data));
      const token = localStorage.getItem('access_token');
      if (token) {
        await dispatch(AddCompanySuccess(response.data.data));
        addNotificationSuccess();
        callback(true);
      } else {
        await dispatch(AddCompanyErr('No Unauthorize access'));
        addNotificationError('No Unauthorize access');
      }
    } catch (err) {
      await dispatch(AddCompanyErr('Something went wrong, Unable to create company.'));
      addNotificationError('Something went wrong, Unable to create company.');
    }
  };
};

const DataRead = () => {
  return async (dispatch) => {
    try {
      await dispatch(getCompaniesBegin());
      const query = await DataService.gql(QUERY.allCompanies);
      const token = localStorage.getItem('access_token');
      if (token) {
        await dispatch(getCompaniesSuccess(query.data.data.allCompanies.nodes));
      } else {
        await dispatch(AddCompanyErr('No Unauthorize access'));
        addNotificationError('No Unauthorize access');
      }
    } catch (err) {
      await dispatch(getCompaniesErr(err));
    }
  };
};

const DataSearch = (searchItem) => {
  return async (dispatch) => {
    try {
      await dispatch(getCompaniesBegin());
      if (searchItem !== '') {
        const query = await DataService.get(`/data/search/${searchItem}`);
        await dispatch(getCompaniesSuccess(query.data.data));
      } else {
        try {
          const query = await DataService.get('/data/all');
          await dispatch(getCompaniesSuccess(query.data.data));
        } catch (err) {
          await dispatch(getCompaniesErr(err));
        }
      }
    } catch (err) {
      await dispatch(getCompaniesErr(err));
    }
  };
};

const DataUpdate = (id, data, callback) => {
  return async (dispatch) => {
    try {
      await dispatch(UpdateCompanyBegin());
      await DataService.gql(QUERY.updateCompany({ id, ...data }));
      await dispatch(UpdateCompanySuccess());
      updateNotificationSuccess();
      callback(true);
    } catch (err) {
      await dispatch(UpdateCompanyErr(err));
      updateNotificationError(err);
    }
  };
};

const DataDelete = ({ id, getData }) => {
  return async (dispatch) => {
    try {
      await dispatch(DeleteCompanyBegin());
      const data = await DataService.gql(QUERY.updateCompany({ id, isActive: false }));

      await dispatch(DeleteCompanySuccess(data.data));
      await getData();
      deleteNotificationSuccess();
    } catch (err) {
      await dispatch(DeleteCompanyErr(err));
      deleteNotificationError(err);
    }
  };
};

export { DataRead, DataSearch, DataSubmit, DataDelete, DataUpdate };
